export default function () {
  return {
    user: {},
    profile: {},
    group: []
  }
}
